import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, StarIcon, XIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const essentialItems = ['Manual Maestro de Hierbas Ancestrales', 'Bonus 1: Farmacia en Macetas', 'Bonus 2: Recetario Medicina en la Cocina', 'Bonus 3: Protocolo Detox 7 Días', 'Bonus 4: Manual de Tés y Elixires Rápidos', 'Bonus 5: Glosario de Enfermedades A-Z', 'Bonus 6: Guía de Secado y Conservación'];
interface PricingCardProps {
  idAttr?: string;
}
export function PricingCard({
  idAttr = 'pricing'
}: PricingCardProps) {
  return <section id={idAttr} className="py-6 sm:py-12 px-4 bg-brand-paper scroll-mt-10" data-id="element-103">
      <div className="max-w-4xl mx-auto" data-id="element-104">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-5 sm:mb-8" data-id="element-105">
          <h2 className="text-xl sm:text-3xl font-serif font-bold text-brand-forest mb-2 leading-tight" data-id="element-106">
            Elige tu Nivel de Independencia Hoy
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 items-start" data-id="element-107">
          {/* OPCIÓN 1: KIT ESENCIAL */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white border-2 border-brand-forest/30 rounded-2xl p-5 sm:p-6 shadow-lg relative" data-id="element-108">
            <h3 className="text-base sm:text-lg font-bold text-brand-forest mb-2 uppercase" data-id="element-109">
              Opción 1: Kit Esencial
            </h3>
            <p className="text-xs sm:text-sm text-brand-muted mb-5" data-id="element-110">
              Lo fundamental para comenzar tu camino natural.
            </p>

            <div className="space-y-2.5 mb-5" data-id="element-111">
              {essentialItems.map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-112">
                  <CheckIcon className="w-4 h-4 sm:w-5 sm:h-5 text-brand-forest shrink-0 mt-0.5" data-id="element-113" />
                  <span className="text-xs sm:text-sm text-brand-text font-medium leading-snug" data-id="element-114">
                    {item}
                  </span>
                </div>)}
              <div className="flex items-start gap-2" data-id="element-115">
                <XIcon className="w-4 h-4 sm:w-5 sm:h-5 text-red-500 shrink-0 mt-0.5" data-id="element-116" />
                <span className="text-xs sm:text-sm text-brand-muted font-medium leading-snug" data-id="element-117">
                  No incluye Manual de Tinturas
                </span>
              </div>
            </div>

            <div className="flex justify-between items-center border-t border-brand-border pt-4 mb-5" data-id="element-118">
              <div data-id="element-119">
                <span className="text-[10px] sm:text-xs text-brand-muted uppercase font-bold block" data-id="element-120">
                  Precio Hoy
                </span>
              </div>
              <div className="text-right" data-id="element-121">
                <span className="text-2xl sm:text-3xl font-bold text-brand-forest" data-id="element-122">
                  $19.90 USD
                </span>
              </div>
            </div>

            <CTAButton href="https://kit-online-2026.myshopify.com/cart/44780443009159:1" variant="outline" className="w-full" data-id="element-123">
              ELEGIR ESTE KIT
            </CTAButton>
          </motion.div>

          {/* OPCIÓN 2: SISTEMA COMPLETO */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-brand-forest text-brand-paper rounded-2xl p-5 sm:p-6 shadow-2xl relative border-2 border-brand-terracotta transform md:-translate-y-4" data-id="element-124">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-terracotta text-white font-bold px-3 py-1 rounded-full text-[10px] sm:text-xs uppercase tracking-wide flex items-center gap-1 whitespace-nowrap shadow-md" data-id="element-125">
              <StarIcon className="w-3 h-3 fill-current" data-id="element-126" />
              Recomendado
            </div>

            <h3 className="text-base sm:text-lg font-bold text-brand-terracotta-light mb-2 mt-1 uppercase" data-id="element-127">
              Opción 2: Sistema Completo ⭐
            </h3>
            <p className="text-xs sm:text-sm text-brand-paper/80 mb-5" data-id="element-128">
              La transformación definitiva. Todo lo que necesitas para sanar.
            </p>

            <div className="space-y-2.5 mb-5" data-id="element-129">
              {essentialItems.map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-130">
                  <CheckIcon className="w-4 h-4 sm:w-5 sm:h-5 text-brand-terracotta-light shrink-0 mt-0.5" data-id="element-131" />
                  <span className="text-xs sm:text-sm font-medium leading-snug" data-id="element-132">
                    {item}
                  </span>
                </div>)}
              <div className="flex items-start gap-2 bg-white/10 p-3 rounded-xl border border-brand-terracotta/40 mt-2" data-id="element-133">
                <CheckIcon className="w-4 h-4 sm:w-5 sm:h-5 text-brand-terracotta-light shrink-0 mt-0.5" data-id="element-134" />
                <div data-id="element-135">
                  <span className="text-xs sm:text-sm font-bold text-brand-terracotta-light block mb-0.5" data-id="element-136">
                    🌟 PLUS: Manual Maestro de Aceites y Tinturas Madre
                  </span>
                  <span className="text-[10px] sm:text-xs text-brand-paper/70 leading-snug" data-id="element-137">
                    Fabrica tus propios extractos potentes en casa con dosis
                    exactas.
                  </span>
                </div>
              </div>
            </div>

            <div className="flex justify-between items-center border-t border-white/20 pt-4 mb-5" data-id="element-138">
              <div data-id="element-139">
                <span className="text-[10px] sm:text-xs text-brand-paper/60 uppercase font-bold block" data-id="element-140">
                  Precio Hoy
                </span>
              </div>
              <div className="text-right" data-id="element-141">
                <span className="text-3xl sm:text-4xl font-bold text-white" data-id="element-142">
                  $26.90 USD
                </span>
              </div>
            </div>

            <CTAButton href="https://kit-online-2026.myshopify.com/cart/44780447236231:1" variant="primary" className="w-full" data-id="element-143">
              OBTENER EL SISTEMA COMPLETO
            </CTAButton>
          </motion.div>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 mt-6 sm:mt-8 text-[10px] sm:text-xs text-brand-muted font-medium" data-id="element-144">
          <span data-id="element-145">🔒 Pago 100% Seguro</span>
          <span className="text-brand-muted/50" data-id="element-146">•</span>
          <span data-id="element-147">📥 Entrega Inmediata</span>
          <span className="text-brand-muted/50" data-id="element-148">•</span>
          <span data-id="element-149">🌍 Paga en tu Moneda Local</span>
          <span className="text-brand-muted/50" data-id="element-150">•</span>
          <span data-id="element-151">🛡️ Garantía Total</span>
        </div>
      </div>
    </section>;
}